import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { InlineLink } from "../../components/ui";
import SplitScreenContent from "../../components/SplitScreenContent";

export const leistungssteigerungen = {
  title: "Leistungssteigerung für luftgekühlte Porsche",
  titleImageUrl: "4l/after_compressed/4.jpg",
  meta: {
    title:
      "Porsche Tuning & Leistungssteigerung – Luftgekühlt | WTM Sportwagen",
    description:
      "Mehr Leistung für Ihren luftgekühlten Porsche: Hubraumerweiterung, Einzeldrossel, Sportnockenwelle & mehr – individuell abgestimmt von WTM Sportwagen.",
  },
  content: [
    {
      type: "hero_image",
      backgroundImage:
        "https://res.cloudinary.com/donwh3eei/image/upload/v1756323651/gallery/frank_kayser/M10_6886_ivl5s1.jpg",
      headline: "Porsche Motorenbau & Tuning",
      // description:
      // "WTM steht für kompromisslosen Motorenbau. Von Hubraum-Erweiterung über Einzeldrossel-Anlagen bis zu High-End-Komponenten erschaffen wir luftgekühlte Porsche-Motoren, die Charakter und Kraft neu definieren.",
      hasVignette: true,
      overlayOpacity: 0.01,
    },
    {
      type: "text_section_hero",
      // headline: "Porsche Motorenbau & Tuning",
      lead: "WTM steht für kompromisslosen Motorenbau. Von Hubraum-Erweiterung über Einzeldrossel-Anlagen bis zu High-End-Komponenten erschaffen wir luftgekühlte Porsche-Motoren, die Charakter und Kraft neu definieren.",
      highlight: "Wir denken in Konzepten, nicht in Einzelteilen.",

      spacing: "tight_top_comfortable_bottom",
      size: "lg",
      variant: "primary",
      margin: false,
    },
    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_6744_oattgo",
      headline: "Leistungssteigerung bei WTM",
      rightContent: (
        <SplitScreenContent
          headline="Porsche Tuning mit Anspruch"
          intro="Bei WTM Sportwagen geht es nicht nur um PS, sondern um Fahrgefühl, Reaktionsfreude und mechanischen Charakter. Jede Leistungssteigerung ist ein maßgeschneidertes Konzept, perfekt abgestimmt auf Ihren Motor, Ihr Fahrzeug und Ihren Fahrstil."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Konzepte, nicht Einzelteile",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Wir denken in Konzepten, nicht in Einzelteilen. Jedes Projekt ist ein Unikat, das die DNA Ihres Porsche respektiert und gleichzeitig Performance und Emotion verstärkt.<a href='/motorsport' class='hyperlink'>Besuchen Sie auch unsere Rubrik Motorsport</a>, falls Sie nach ganzheitlichen Lösungen für Ihren Porsche suchen.",
            },
            {
              type: "heading",
              text: "Moderne Technik, klassischer Charakter",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Luftgekühlt, aber nicht von gestern: Unsere Umbauten zeigen, wie weit sich klassische Porsche-Technik verfeinern lässt, ohne den ursprünglichen Charakter zu verlieren. <a href='/restauration' class='hyperlink'>Gerne planen wir mit Ihnen eine Leistungssteigerung auch im Rahmen eines Restaurationsprojekts</a>.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "Unsere Schwerpunkte",
                items: [
                  "Hubraumerweiterung auf 3.4L, 3.6L, 3.8L oder 4.0L – je nach Basis (911, 964, 993)",
                  "Optische Veredelung & Motor-Ästhetik – wir bauen keine anonymen PS-Maschinen, sondern schöne, saubere und detailverliebte Motoren, die man gerne offen zeigt",
                  "Abgestimmte Konzepte je nach Fahrzeug und Fahrstil - oberste Priorität hat das Fahrgefühl, die Standfestigkeit, das Ansprechverhalten und die Fahrbarkeit",
                  "<a href='/porsche-gutachten' class='hyperlink'>100% konform mit TÜV-Eintragung und reibungslosen Prozessen für Gutachten</a>",
                ],
                highlightedIndices: [0, 1, 2],
                icon: "check",
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Leistungssteigerung - Porsche Tuning",
      navbarHeight: 0,
    },
    // {
    //   type: "gallery_grid",
    //   maxHeight: "600px",
    //   animationSpeed: "3500",
    //   images: [
    //     {
    //       src: "gallery/engine_builds/964_4L/P1020736_dmcacw",
    //       alt: "Porsche engine detail",
    //     },
    //     {
    //       src: "gallery/engine_builds/964_4L/P1020634_osl7du",
    //       alt: "Porsche engine detail",
    //     },
    //     {
    //       src: "gallery/engine_builds/964_4L/P1020586_xgv0ge",
    //       alt: "Porsche engine detail",
    //     },
    //     {
    //       src: "gallery/engine_builds/964_4L/P1020568_wv3lro",
    //       alt: "Porsche engine detail",
    //     },
    //     {
    //       src: "gallery/engine_builds/964_4L/DSC00348_lbsoqy",
    //       alt: "Porsche engine detail",
    //     },
    //     {
    //       src: "gallery/engine_builds/964_4L/DSC00341_ced8vd",
    //       alt: "Porsche engine detail",
    //     },
    //   ],
    //   spacing: "none",
    //   maxWidth: "none",
    // },
    {
      type: "cta-with-modal",
      headline: "Unverbindlich anfragen – wir beraten Sie persönlich",
      paragraph:
        "Ob komplette Motorrevision oder individuelle Beratung – wir sind persönlich für Sie da. Auf Wunsch mit versichertem Hol- und Bringservice deutschlandweit.",
      darkMode: true,
      spacing: "comfortable_top_tight_bottom",
    },

    {
      type: "lighthouse-grid",
      variant: "secondary",
      spacing: "comfortable_top_spacious_bottom",
      maxWidth: "none",
      showHeader: true,
      stickyHeadline: "Referenzprojekt: 964 Atmo 4.0 RS",
      title: "Gallerie",
      subtitle: "Beispielprojekt - 964 Atmo 4.0 RS",
      description:
        "4.0 Liter Hubraum, Einzeldrossel, 400PS - Unser 964-Referenzumbau vereint kompromisslose Performance mit voller Alltagstauglichkeit.",
      navbarHeight: 0,
      images: [
        {
          src: "gallery/engine_builds/964_sommerfest/IMG_0870_2_voadjb",
          alt: "Porsche 964 4L engine build - assembled engine",
        },
        {
          src: "gallery/engine_builds/964_sommerfest/IMG_0981_2_fu3hdw",
          alt: "Porsche 964 4L engine build - final inspection",
        },

        {
          src: "gallery/engine_builds/964_sommerfest/IMG_0874_2_olvsmk",
          alt: "Porsche 964 4L engine build - engine components",
        },
        {
          src: "gallery/engine_builds/964_sommerfest/IMG_0871_2_crkgoa",
          alt: "Porsche 964 4L engine build - detailed view",
        },

        {
          src: "gallery/engine_builds/964_sommerfest/IMG_0911_2_wy8kre",
          alt: "Porsche 964 4L engine build - internal components",
        },

        {
          src: "gallery/engine_builds/964_sommerfest/IMG_0940_2_lcqrxu",
          alt: "Porsche 964 4L engine build - final inspection",
        },

        {
          src: "gallery/engine_builds/964_4L/DSC00341_ced8vd",
          alt: "Porsche 964 4L engine build - final inspection",
        },
        {
          src: "gallery/engine_builds/964_sommerfest/IMG_0877_2_tqnesk",
          alt: "Porsche 964 4L engine build - final assembly",
        },

        {
          src: "gallery/engine_builds/964_4L/P1020634_osl7du",
          alt: "Porsche 964 4L engine build - final inspection",
        },
        {
          src: "gallery/engine_builds/964_sommerfest/IMG_0995_2_vw6ypq",
          alt: "Porsche 964 4L engine build - final inspection",
        },

        {
          src: "gallery/engine_builds/964_4L/P1020716_rgeazt",
          alt: "Porsche 964 4L engine build - final inspection",
        },
        {
          src: "gallery/engine_builds/964_4L/P1020738_e18ve9",
          alt: "Porsche 964 4L engine build - final inspection",
        },
      ],
      imageWidth: 800,
      imageCrop: "fill",
      imageGravity: "center",
      highQuality: true,
      showThumbnails: true,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_7408_efo22q",
      headline: "Typische Projekte nach Modellreihe",
      rightContent: (
        <SplitScreenContent
          headline="Wir machen es möglich"
          intro="Jede Generation des 911 hat ihre eigenen Stärken – und Potenziale für mehr Performance. Hier ein Überblick über typische Umbauten, die wir regelmäßig realisieren:"
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "911 F-Modell (2.0–2.4 L)",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Feine Vergaserabstimmung, optimierte Nockenwellen oder Einzeldrosseln verleihen den frühen Elfern mehr Drehfreude und Charakter, ohne ihren Ursprung zu verfälschen.",
            },
            {
              type: "heading",
              text: "911 G-Modell (2.7–3.2 L)",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Vom 3.2-Upgrade bis hin zu modernen Einspritz- und Auspufflösungen – das G-Modell gewinnt an Durchzugskraft und bleibt gleichzeitig ein alltagstauglicher Klassiker.",
            },
            {
              type: "heading",
              text: "964 (3.6 L)",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Beliebt sind Hubraumerweiterungen auf 3.8 oder 4.0 Liter, kombiniert mit optimierter Ansaugung und Motorelektronik. Das Ergebnis: ein standfester Motor mit satter Leistung und unglaublichem Klang.",
            },
            {
              type: "heading",
              text: "993 (3.6 L)",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Die letzte luftgekühlte Generation profitiert besonders von 3.8-Liter-Umbauten, leichtere Schwungmassen und optimierte Ansaugung – für mehr Drehmoment und Spontanität.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "Warum WTM Sportwagen?",
                items: [
                  "Versicherter Hol- und Bringservice deutschlandweit",
                  "Kunden aus Köln, Frankfurt, Düsseldorf, Kassel und bundesweit vertrauen uns",
                  "Transparente Projektbegleitung mit regelmäßigen WhatsApp-Updates",
                  "Langjährige Erfahrung mit luftgekühlten Porsche-Motoren (356 bis 993)",
                ],
                highlightedIndices: [0, 1],
                icon: "check",
              },
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline:
                  "Jetzt Projekt besprechen – persönlich & unverbindlich",
                paragraph:
                  "Ob dezente Optimierung oder kompromissloser Umbau – wir beraten Sie ehrlich, kompetent und auf Augenhöhe.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Motortuning - Porsche Projekte",
      navbarHeight: 0,
    },

    // {
    //   type: "engine-stages",
    // },

    // {
    //   type: "card-list",
    //   layout: "tabbed",
    //   theme: "card-primary",
    //   cards: [
    //     {
    //       id: "tab-beratung",
    //       tabName: "Beratung",
    //       headline: "Was passt zu Ihrem Fahrzeug?",
    //       introduction:
    //         "Jeder Umbau beginnt mit einem Gespräch – denn kein Porsche ist wie der andere.",
    //       image: "misc_compressed/thinking.jpg",
    //       keyPoints: [
    //         "Fahrprofil & Einsatzzweck klären",
    //         "Zielsetzung: Alltag, Trackday oder reines Fahrerlebnis",
    //         "Technische Machbarkeit & Kostenrahmen definieren",
    //       ],
    //     },
    //     {
    //       id: "tab-umsetzung",
    //       tabName: "Umsetzung",
    //       headline: "Motor, Getriebe & Setup – perfekt abgestimmt",
    //       introduction:
    //         "Jede Komponente wird abgestimmt und integriert. Keine halben Sachen.",
    //       image: "4l/after_compressed/10.jpg",
    //       keyPoints: [
    //         "Motorumbau mit Bearbeitung & Abstimmung",
    //         "Auspuff, Ansaugung, ECU – abgestimmt im Paket",
    //         "Auf Wunsch inkl. Getriebeübersetzung & Sperrdifferential",
    //       ],
    //     },
    //     {
    //       id: "tab-testfahrt",
    //       tabName: "Fahrtest",
    //       headline: "Kaltstart. Warmlauf. Gänsehaut.",
    //       introduction:
    //         "Nach dem Umbau folgt der Testlauf – und die erste Fahrt mit echtem Grinsen im Gesicht.",
    //       image: "4l/after_compressed/2.jpg",
    //       keyPoints: [
    //         "Testlauf & ECU-Feinabstimmung",
    //         "Dokumentation & Prüfprotokoll",
    //         "Einweisung & Übergabe – auf Wunsch mit Transport",
    //       ],
    //     },
    //   ],
    // },

    {
      type: "relevant-posts",
      postSlugs: [
        "blog-post-5",
        "964-993-leistungssteigerung",
        "964-4.0-projekt",
        "964-rsr-projekt",
        
      ],
      headline: "Werkstatt Journal: Performance & Tuning bei WTM",
      introText:
        "Entdecken Sie weitere Artikel zu diesem Thema aus unserem Werkstatt Journal.",
      darkMode: false,
    },
  ],
};
